import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.b2{gap:2rem;}.ssr-plugin'
import '.aw{text-align:center;}.ssr-plugin'
import '.j{gap:1.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { PageLayout } from '../layout/PageLayout'
import { Title } from '../../components/core/typography/Title'
import { Text } from '../../components/core/typography/Text'
import { useState, useEffect } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import { DiscoverSection } from './sections/Discover'
import Column from '@app/components/layout/Column'
import { HousingFormsSection } from './sections/HousingForms'
import { AboutSection } from './sections/About'
import { StatsAndCtaSection } from './sections/StatsAndCta'
import { HeaderTabs } from '@app/components/core/tabs/HeaderTabs'
import { pages } from '@app/util/links'
import { useParamSearch } from '@app/util/hooks/useParamState'
import { SearchBar } from '@app/components/blocks/searchBar/SearchBar'
import { navigate } from 'wouter/use-browser-location'
import useMediaQuery from '@app/util/useMediaQuery'
import { StoriesSection } from './sections/Stories'
import { useQuery } from '@based/sdk/react'
import { MaintenancePage } from './MaintenancePage'
import { StaticPageSeo } from '@app/components/core/seo/StaticPageSeo'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import { useRootDomain } from '@app/util/hooks/useRootDomain'
import {
  buildOrganizationJsonLd,
  buildWebSiteJsonLd,
} from '@app/util/seo/buildOrganizationJsonLd'
import InitiativeDefIcon from '@app/assets/discovery/initiativen-default.svg'
import LocationDefIcon from '@app/assets/discovery/location-default.svg'
import RegionDefIcon from '@app/assets/discovery/regio-default.svg'
import HousingFormDefIcon from '@app/assets/discovery/woonvorm-default.svg'
import InitiativeActiveIcon from '@app/assets/discovery/initiativen-active-hover.svg'
import LocationActiveIcon from '@app/assets/discovery/location-active-hover.svg'
import RegionActiveIcon from '@app/assets/discovery/regio-active-hover.svg'
import HousingFormActiveIcon from '@app/assets/discovery/woonvorm-active-hover.svg'

const tabs = {
  initiatives: 'initiatives',
  locations: 'locations',
  regions: 'regions',
  housingForms: 'housingForms',
} as const

export const Landing = () => {
  const isMobile = useMediaQuery()
  const translations = useTranslations().app
  const { title: siteTitle } = useTenantContext()
  const rootDomain = useRootDomain()
  const { data: maintenance } = useQuery('maintenance-status')

  const [searchTerm, setSearchTerm] = useParamSearch()
  const [searchBarInput, setSearchBarInput] = useState('')

  useEffect(() => {
    if (searchTerm.trim() !== '') {
      const searchParam = encodeURIComponent(searchTerm)
      navigate(`${pages.initiatives}?search=${searchParam}`)
    }
  }, [searchTerm, setSearchTerm])

  if (maintenance?.enabled) {
    return <MaintenancePage message={maintenance.message} />
  }

  const placeholder = isMobile
    ? translations.discoveryPage.searchPlaceholder.mobile
    : translations.discoveryPage.searchPlaceholder.initiatives

  return (
    <PageLayout gap={isMobile ? '1rem' : '3rem'}>
      <StaticPageSeo
        path={pages.home}
        pageTitle={translations.landingPage.title}
        description={translations.landingPage.description}
        useSiteDefaultImage
        jsonLd={[
          buildOrganizationJsonLd(rootDomain, siteTitle),
          buildWebSiteJsonLd(rootDomain, siteTitle),
        ]}
      />
      {/* Hero Section */}
      <div className="a b r b2"
        style={{
          padding: isMobile ? '1rem' : '4rem 2rem',}}
      >
        <div className="aw a b j"
        >
          <Title.H1>{translations.landingPage.title}</Title.H1>
          <Text.Large>{translations.landingPage.description}</Text.Large>
        </div>
        <Column
          alignItems="center"
          gap="2.5rem"
          style={{ alignSelf: 'center' }}
        >
          <HeaderTabs.Group
            selectedTab={tabs.initiatives}
            style={{ gap: isMobile ? '1rem' : '2.5rem' }}
          >
            <HeaderTabs.Tab
              icon={InitiativeDefIcon}
              activeIcon={InitiativeActiveIcon}
              label={translations.discoveryPage.initiatives}
              value={tabs.initiatives}
              href={pages.initiatives}
              onSelectTab={() => navigate(pages.initiatives)}
            />
            <HeaderTabs.Tab
              icon={LocationDefIcon}
              activeIcon={LocationActiveIcon}
              label={translations.discoveryPage.plots}
              value={tabs.locations}
              href={pages.plots}
              onSelectTab={() => navigate(pages.plots)}
            />
            <HeaderTabs.Tab
              icon={RegionDefIcon}
              activeIcon={RegionActiveIcon}
              label={translations.discoveryPage.regions}
              value={tabs.regions}
              href={pages.regions}
              onSelectTab={() => navigate(pages.regions)}
            />
            <HeaderTabs.Tab
              icon={HousingFormDefIcon}
              activeIcon={HousingFormActiveIcon}
              label={translations.discoveryPage.housingForms}
              value={tabs.housingForms}
              href={pages.housingForms}
              onSelectTab={() => navigate(pages.housingForms)}
            />
          </HeaderTabs.Group>
          <SearchBar
            placeholder={placeholder}
            searchTerm={''}
            setSearchTerm={setSearchTerm}
            searchBarInput={searchBarInput}
            setSearchBarInput={setSearchBarInput}
            currentView={'grid'}
            onSwitchView={() => navigate(pages.initiatives + '?view=map')}
            onFiltersOpen={() => navigate(pages.initiatives)}
          />
        </Column>
      </div>
      <Column alignItems="stretch" gap={isMobile ? '3rem' : '6.25rem'}>
        <DiscoverSection />
        <HousingFormsSection />
        <AboutSection />
        <StoriesSection />
        <StatsAndCtaSection />
        {/* <NewsletterSection />
        <styled.div style={{ height: '6.25rem' }} /> */}
      </Column>
    </PageLayout>
  )
}
